import React from 'react';
import { createRoot } from 'react-dom/client';

import { BrowserRouter } from 'react-router-dom';
import './assets/base.scss';
import Main from './DemoPages/Main';
import configureAppStore from './config/configureStore';
import { Provider } from 'react-redux';
import ErrorBoundary from './components/ErrorBoundary';

const store = configureAppStore();
const rootElement = document.getElementById('root');

const renderApp = (Component) => (
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Component />
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

const root = createRoot(rootElement);
root.render(renderApp(Main));

// Vite HMR
if (import.meta.hot) {
  import.meta.hot.accept('./DemoPages/Main', (newModule) => {
    if (newModule) {
      root.render(renderApp(newModule.default));
    }
  });
}
